import Tasks from 'APP/Tasks';
import { PayloadType, IMessagePayload } from 'APP/model/message/messageModel.types';

interface ICanSendMessageParams {
  groupId: string;
  isCheckSlowMode?: boolean;
  isNewMessage?: boolean;
  payload: IMessagePayload;
}

interface ICanSendMessage {
  result: boolean;
  error?: string;
}

export function canSendMessage(data: ICanSendMessageParams): ICanSendMessage {
  const { groupId, isCheckSlowMode = true, isNewMessage = true, payload } = data;

  if (isCheckSlowMode) {
    const result = Tasks.messaging.checkSlowMode();
    if (!result.result) {
      return result;
    }
  }

  if (payload.payloadType === PayloadType.VoiceMessage) {
    const result = Tasks.group.checkP2PVoicePermission(groupId);
    if (!result.result) {
      return result;
    }
  }

  return Tasks.group.checkSendMessagePermissions({ groupId, isNewMessage, payload });
}
